import { Component, ElementRef, OnInit } from "@angular/core";

import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

import { ActivatedRoute, Router } from "@angular/router";

import { View } from "ol";

import TileLayer from "ol/layer/Tile";

import { OSM } from "ol/source";

import axios from "src/app/Service/axios";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import * as XLSX from 'xlsx';

import Map from 'ol/Map';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';

import * as olProj from 'ol/proj';

import { MapService } from "src/app/Service/map.service";

import { GurdServiceService } from "src/app/Service/gurd-service.service";

declare let $: any;

@Component({

  selector: 'manageEvent',

  templateUrl: './manageEventComponent.html',

})

export class ManageEventComponent implements OnInit {

  constructor(

    private el: ElementRef,

    private notifyService: NotificationService,

    private router: Router,

    private otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private mapService: MapService,

    private gurdService: GurdServiceService,

  ) {

  }

  map: any;

  domain: any;

  journalTypeData: any;

  domainVal: number = -1;

  typeDataVal: number = -1;

  EventsData: any = [];

  fullEventsData: any = [];

  fileName = 'LiveJournal.xlsx';

  location: any = [51.3833554, 35.6770113];

  dateTime: Date = new Date();

  ismapCreate: boolean = false;

  bDailyEvent: boolean = false;

  eventModel: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iMobileDomain: new FormControl("-1"),

    tiJournalType: new FormControl("-1"),

    strDateTime: new FormControl(""),

    strDate: new Date().valueOf(),

    strTime: new FormControl(`${this.dateTime.getHours()}:${this.dateTime.getMinutes()}`),

  });

  ngOnInit(): void {

    this.route.url.subscribe((segment) => {

      if (segment[0].path == 'daily-event') this.bDailyEvent = true;

      this.fileName = 'dailyEvent.xlsx'

      this.getDomain();

      this.journalType();

    })

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

  }

  search() {

    if (!this.bDailyEvent) {

      var Interval;

      clearInterval(Interval)

      let time = document.getElementById("time") as any;

      this.eventModel.controls["strTime"].setValue(time.value);

    }

    this.eventModel.controls["strDateTime"].setValue("");

    this.getEventsData();

    this.EventsData = [];

    this.fullEventsData = [];

    if (!this.bDailyEvent) {

      Interval = setInterval(() => {

        this.getEventsData();

      }, 30000);

    }

  }

  getDomain = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`,
      {}
    );
    this.domain = JSON.parse(resp.data);
  }

  journalType = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    } as any;
    const resp = await axios.post(`GetJournalType`, model);
    this.journalTypeData = JSON.parse(resp.data);
    if (this.journalTypeData.iResult == 0) {
      this.notifyService.showError(this.journalTypeData.strError);
      return;

    }
  }

  getEventsData = async () => {

    var model = this.otherService.stringNumberToNumber(this.eventModel.value);

    this.otherService.Showspinner();

    const resp = await axios.post(this.bDailyEvent ? 'Journal_DailyReport' : `GetLastJournal`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data)

    if (res.iResult == 0) return this.notifyService.showError(res.strError)

    JSON.parse(resp.data).forEach((element: any) => {

      this.EventsData.push(element);

      this.fullEventsData.push(element);

    });

    if (this.domainVal != -1) {

      this.EventsData = this.fullEventsData.filter((el: any) => {

        if (this.typeDataVal != -1) {

          return this.typeDataVal == el.tiJournalType && this.domainVal == el.iMobileDomain;

        }

        else {
          return this.domainVal == el.iMobileDomain

        }

      });

    }

    else if (this.typeDataVal != -1) {

      this.EventsData = this.fullEventsData.filter((el: any) => {

        return this.typeDataVal == el.tiJournalType;

      });

    }

    if (JSON.parse(resp.data).length == 0) {

      const dateTime = await axios.post(`GetCurrentDateTime`, {});

      this.eventModel.controls["strDateTime"].setValue(dateTime.data);

    }

    else {

      this.eventModel.controls["strDateTime"].setValue(this.EventsData[0].strCurrentDateTime);
    }

    if ($('#show-last-th').is(":checked")) {

      setTimeout(() => {

        var scrollsave = $('#scroll-handel').prop('scrollHeight');

        $('#scroll-handel').animate({ scrollTop: scrollsave }, 1000);

      }, 100);

    }

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  newOpenMap() {

    this.map = new Map({
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: 'map-modal',
      layers: [
        new TileLayer({
          source: new OSM({}),
        })
      ],
      view: new View({
        center: olProj.fromLonLat(this.location),
        zoom: 5,
      }),
    }) as any;
  }

  openMap(flat: any, fLon: any, time: any, comment: any) {
    if (!this.ismapCreate) {
      this.newOpenMap();
      this.ismapCreate = true;
    }
    this.mapService.removeMarkerById("marker", this.map);
    var marker = this.mapService.createMarker([fLon, flat],
      '../../assets/Img/marker5.png',
      `marker`,
      ``,
      {
        html: `
        <p class='text-dark mb-0 f12'>${comment}</p>
        `,
      });
    this.map.addLayer(marker);
    this.mapService.fitMap([{ fLon: fLon, fLat: flat }], this.map);
    setTimeout(() => {
      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }
        setTimeout(() => {
          var el = this.mapService.mapPointerMove(
            this.map.getEventPixel(e.originalEvent),
            this.map
          );
          this.showData(el);

        }, 50);
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 500);
  }

  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        tooltip
          .attr(
            'data-bs-original-title',
            item.featureLayer.feature.get('data').html
          )
          .tooltip('show');
      }
    } else {
      tooltip.tooltip('hide');
    }
  }

  changeDomain(e: any) {

    this.domainVal = e.value;

    this.EventsData = this.fullEventsData.filter((el: any) => {

      if (this.typeDataVal != -1) {

        return e.value == el.iMobileDomain && this.typeDataVal == el.tiJournalType;

      }

      else {

        return e.value == el.iMobileDomain;

      }

    });

  }

  changeTypeData(e: any) {
    this.typeDataVal = e.value;

    this.EventsData = this.fullEventsData.filter((el: any) => {

      if (this.domainVal != -1) {
        return e.value == el.tiJournalType && this.domainVal == el.iMobileDomain;

      }
      else {
        return e.value == el.tiJournalType;

      }

    });
  }

  sortByDate() {
    this.EventsData.sort((a: any, b: any) => {
      return new Date(b.strDate) as any - (new Date(a.strDate) as any);
    });
  }

  filter_list(val: any) {

    this.EventsData = this.fullEventsData.filter((el: any) => {

      return el.strFullName.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.EventsData = this.fullEventsData;

    }

  }

}
